import React, { Fragment, useState, useEffect } from "react";
import Fab from "@mui/material/Fab";
import Button from "@mui/material/Button";
import AssignTagsCategoriesModal from "./AssignTagsCategoriesModal";

import { Link } from "react-router-dom";
import { config_url } from "../../config";
import axios from "axios";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Swal from "sweetalert2";
import {
  RiAddCircleFill,
  RiDeleteBin6Fill,
  RiAddCircleLine,
  RiEdit2Line,
} from "react-icons/ri";
import { Tooltip } from "@mui/material";
import UpdBlog from "./UpdBlog";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function ListBlogs() {
  const [blogs, setBlogs] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedBlogId, setSelectedBlogId] = useState(null);
  const [rowCategory, setRowCategory] = useState({});
  const [open, setOpen] = useState(false);
  const [image, setImage] = useState("");
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleOpenModal = (blogId) => {
    setSelectedBlogId(blogId);
    setModalOpen(true);
  };
  useEffect(() => {
    axios
      .get(`${config_url}/api/blogs`)
      .then((res) => {
        if (Array.isArray(res.data)) {
          setBlogs(res.data);
        } else {
          console.error(
            "Invalid data structure received for categories:",
            res.data
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  }, []);

  const deleteCategory = (id, image) => {
    axios.post(`${config_url}/api/blog/${id}`, { image: image }).then(() => {
      setBlogs(blogs.filter((row) => row.id !== id));
    });
  };
  function popup(id, image) {
    Swal.fire({
      title: "Êtes vous sûr?",
      text: "Vous ne pourrez pas revenir en arrière!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Annuler",
      confirmButtonText: "Oui, supprimez Blog",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteCategory(id, image);
        Swal.fire("Supprimé!", "Blog a été supprimé.", "success");
      }
    });
  }
  const handleLoadModalImage = async (image) => {
    await handleOpen();

    await setImage(image);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const openModal = (row) => {
    setIsModalOpen(true);
    setRowCategory(row);
  };
  return (
    <Fragment>
      {isModalOpen && (
        <UpdBlog
          closeModal={closeModal}
          rowCategory={rowCategory}
          blogs={blogs}
          setBlogs={setBlogs}
        />
      )}{" "}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <img src={image} />
        </Box>
      </Modal>
      <AssignTagsCategoriesModal
        blog_id={selectedBlogId}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      />
      <div className="flex items-center justify-center gap-10 mb-10">
        <Link to="/app/ajoute-categorie">
          <Button variant="outlined" startIcon={<RiAddCircleFill />}>
            Ajoute Categorie Blog
          </Button>
        </Link>
        <Link to="/app/ajoute-tag">
          <Button variant="outlined" startIcon={<RiAddCircleFill />}>
            Ajoute Tag Blog
          </Button>
        </Link>
      </div>
      <div className="mt-10">
        <Link to="/app/ajoute-blog">
          <Fab variant="extended">
            <RiAddCircleLine sx={{ mr: 1 }} size={20} />
            Add Blog
          </Fab>
        </Link>
        <div className="container my-8 w-[1800px]">
          <table className="table-auto w-full border-collapse border border-gray-300 rounded-2xl overflow-hidden">
            <thead>
              <tr className="text-black">
                <th className="py-2 px-4 border border-gray-300 bg-gray-200">
                  Blog Title{" "}
                </th>

                <th className="py-2 px-4 border border-gray-300 bg-gray-200">
                  Date Creation{" "}
                </th>
                <th className="py-2 px-4 border border-gray-300 bg-gray-200">
                  Blog Image
                </th>
                <th className="py-2 px-4 border border-gray-300 bg-gray-200">
                  Meta Image
                </th>

                <th className="py-2 px-4 border border-gray-300 bg-gray-200">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {blogs?.map((item) => (
                <tr key={item.id}>
                  <td className="py-2 px-4 border border-gray-300">
                    {item.title}
                  </td>
                  <td className="py-2 px-4 border border-gray-300">
                    {item.date_created}
                  </td>
                  <td className="flex items-center justify-center py-2 px-4 border border-gray-300">
                    <img
                      src={item.image}
                      alt={item.meta_image}
                      className="w-10 h-10"
                      onClick={() => handleLoadModalImage(item.image)}
                    />
                  </td>
                  <td className="py-2 px-4 border border-gray-300">
                    {item.meta_image}
                  </td>
                  <td className="flex items-center justify-center py-2 px-4 gap-4">
                    <div>
                      <RiDeleteBin6Fill
                        className="collabListDelete"
                        onClick={() => {
                          popup(item.id, item.image);
                        }}
                      />
                    </div>
                    <div className="flex items-center">
                      <Tooltip title="Change Info Order" placement="top">
                        <div className="mt-2">
                          <RiEdit2Line
                            className="collabListEdit"
                            onClick={() => openModal(item)}
                          />
                        </div>
                      </Tooltip>
                    </div>
                    <div className="flex items-center justify-center gap-10">
                      <Button
                        onClick={() => handleOpenModal(item.id)}
                        variant="outlined"
                        startIcon={<RiAddCircleFill />}
                      >
                        Assign Tags Categories To Blog
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}

              {/* Add more rows as needed */}
            </tbody>
          </table>
        </div>{" "}
      </div>
    </Fragment>
  );
}

export default ListBlogs;
